__turbopack_context__.v({
  "anotherPrice": "cartProduct-module-scss-module__Vs1i_G__anotherPrice",
  "cartProduct": "cartProduct-module-scss-module__Vs1i_G__cartProduct",
  "discountPrice": "cartProduct-module-scss-module__Vs1i_G__discountPrice",
  "image": "cartProduct-module-scss-module__Vs1i_G__image",
  "info": "cartProduct-module-scss-module__Vs1i_G__info",
  "input": "cartProduct-module-scss-module__Vs1i_G__input",
  "price": "cartProduct-module-scss-module__Vs1i_G__price",
  "prices": "cartProduct-module-scss-module__Vs1i_G__prices",
  "quantityWrapper": "cartProduct-module-scss-module__Vs1i_G__quantityWrapper",
  "removeAction": "cartProduct-module-scss-module__Vs1i_G__removeAction",
  "rightPart": "cartProduct-module-scss-module__Vs1i_G__rightPart",
  "sizeColorWrapper": "cartProduct-module-scss-module__Vs1i_G__sizeColorWrapper",
  "title": "cartProduct-module-scss-module__Vs1i_G__title",
  "wishlistBtn": "cartProduct-module-scss-module__Vs1i_G__wishlistBtn",
});
